<template>
    <div class="relative" ref="dropdownModal">
        <button 
        class="inline-flex items-center text-gray-500 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm px-4 py-2 h-full" 
        type="button"
        @click="showDropdown = true">
        
            <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="w-5 h-5 me-2"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 4h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v7l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227z" /></svg>{{ $t("provider.auto.filtros") }}<svg class="w-2.5 h-2.5 ms-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
            </svg>
        </button>
        <!-- Dropdown menu -->
        <div 
        class="z-10 w-auto absolute top-10 left-1  bg-white divide-y divide-gray-100 rounded-md shadow border border-eblack-200" 
        :hidden="!showDropdown">
            <div class="w-full flex flex-col gap-4 p-2">
                <fieldset class="border rounded-lg p-2">
                    <legend class="text-sm">{{ $t("provider.auto.pais") }}</legend>
                    <div>
                        <select name="country"
                        class="rounded-md text-sm md:text-md right-1 focus:ring-blue-400"
                        v-model="filters.country"
                        @change="handleFilters()">
                            <option value="">{{ $t("provider.auto.seleccione_el_pais") }}</option>
                            <option v-for="country in countries" v-bind:key="country.id" :value="country.iso2">{{ country.name }}</option>
                        </select>
                    </div>
                </fieldset>
                <fieldset class="border rounded-lg p-2" v-if="location_one.length > 0">
                    <legend class="text-sm">{{ $t("provider.auto.provincia") }}</legend>
                    <div>
                        <select name="location_one"
                        class="rounded-md text-sm md:text-md right-1 focus:ring-blue-400"
                        v-model="filters.location_one"
                        @change="handleFilters()">
                            <option value="">{{ $t("provider.auto.seleccione_la_provincia") }}</option>
                            <option v-for="state in location_one" v-bind:key="state.id" :value="state.name.toLowerCase()">{{ state.name }}</option>
                        </select>
                    </div>
                </fieldset>
                <fieldset class="border rounded-lg p-2" v-if="location_two.length > 0">
                    <legend class="text-sm">{{ $t("provider.auto.canton") }}</legend>
                    <div>
                        <select name="location_two"
                        class="rounded-md text-sm md:text-md right-1 focus:ring-blue-400"
                        v-model="filters.location_two"
                        @change="handleFilters()">
                            <option value="">{{ $t("provider.auto.seleccione_el_canton") }}</option>
                            <option v-for="city in location_two" v-bind:key="city.id" :value="city.name.toLowerCase()">{{ city.name }}</option>
                        </select>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
</template>

<script>
import data from '@/core/data';
import categoryRequests from "@/services/admin/category-service";
export default {
    props:['setFilters'],
    data(){
        return {
            categories:[],
            filters:{
                category:"",
                country:"",
                location_one:"",
                location_two:"",
            },
            showDropdown:false,
            countries:[],
            location_one:[],
            location_two:[],
        }
    },
    watch:{
        'filters.country':{
            handler(value){
                this.loadStates(value)
            },
            immediate:true
        },
        'filters.location_one':{
            handler(value){
                this.loadCities(value)
            },
            immediate:true
        },
    },
    methods:{
        getCategories(){
            categoryRequests.getAllCategories().then(
                res => {
                    if(res.status == 200){
                        let {data} = res
                        this.categories = data;
                    }
                },
                error => {
                    console.log(error)
                }
            )
        },
        handleClickOutside(event) {
            if (this.$refs.dropdownModal && !this.$refs.dropdownModal.contains(event.target)) {
                this.showDropdown = false;
            }
        },
        handleFilters(){
            this.setFilters(this.filters)
        },
        loadStates(value){
            let state = this.countries.filter(item => item.iso2 == value)
            if(state.length > 0){
                this.country_selected = state[0]
                this.location_one = state[0].states
            }
        },
        loadCities(value){
            if(this.country_selected){
                let cities = this.country_selected.states.filter(item => item.name.toLowerCase() == value)

                if(cities.length > 0){
                    this.location_two = cities[0].cities
                }
            }
        },
    },
    mounted(){
        this.getCategories()
        this.countries = data.countriesStatesCities;
        document.addEventListener("click", this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener("click", this.handleClickOutside);
    }
}
</script>

<style lang="scss" scoped>

</style>